import React from 'react';
import { Accent, accentIcon } from '../lib/accents';

export const ImpactCard: React.FC<{ icon: React.ReactNode; title: string; description: string; accent?: Accent }> = ({ icon, title, description, accent = 'primary' }) => (
  <div className="h-full bg-card p-6 rounded-lg border border-border text-center flex flex-col items-center">
    <div className={`${accentIcon[accent]} p-4 rounded-full mb-4`}>
      {icon}
    </div>
    <h3 className="text-lg font-bold text-card-foreground mb-2 font-heading">{title}</h3>
    <p className="text-muted-foreground text-sm flex-grow">{description}</p>
  </div>
);